@if (['EWALLET'].includes(depositSubmitResponse?.family)) {
    @if (depositService.showPixProcessPage()) {
        <app-pix-status-process></app-pix-status-process>
    } @else {
        <app-wallet-process></app-wallet-process>
    }
}
